export function navItems({ grupo, isPizzaGroup }) {
  const items = [];

  const hasGroup = Boolean(grupo?.Id);

  if (!hasGroup) {
    items.push({ key: 'tipo', name: 'Tipo', disabled: !hasGroup });
  }

  items.push({ key: 'detalhes', name: 'Detalhes', disabled: !hasGroup });

  if (isPizzaGroup) {
    items.push({
      key: 'tamanhos-pizza',
      name: 'Tamanhos',
      disabled: !hasGroup,
    });

    items.push({
      key: 'bordas',
      name: 'Bordas',
      disabled: !hasGroup,
    });
  } else {
    items.push({
      key: 'tamanhos',
      name: 'Tamanhos',
      disabled: !hasGroup,
    });
  }

  if (hasGroup) {
    items.push({
      key: 'sabores',
      name: 'Sabores',
    });
  }

  if (hasGroup) {
    items.push({
      key: 'horarios',
      name: 'Horários',
    });
    items.push({
      key: 'adicionais',
      name: 'Adicionais',
    });
  }

  return items;
}
